import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-672e7690"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-switcher" }
const _hoisted_2 = { class: "company-switcher__title" }
const _hoisted_3 = { class: "company-switcher__list" }
const _hoisted_4 = { class: "company-switcher__avatar" }
const _hoisted_5 = { class: "company-switcher__label" }
const _hoisted_6 = { key: 0 }

import { PropType, ref } from 'vue'
import { UserCompany } from '@/models/company.model'
import { useAuthStore } from '@/store/auth'
import { FORMATS, SIZES } from '@/enums/components'
import BaseButton from '@/components/BaseButton.vue'
import ModalWrapper from '@/components/ModalWrapper.vue'
import FormCreateCompany from '@/components/FormCreateCompany.vue'
import { storeToRefs } from 'pinia'
import { PERMISSIONS } from '@/enums/settings'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySwitcher',
  props: {
  userCompanies: {
    type: Array as PropType<UserCompany[]>,
    required: true,
  },
},
  emits: ['onSelect'],
  setup(__props, { emit: emits }) {

const authStore = useAuthStore()




const isSelected = (id: number) => authStore.selectedCompanyId === id
const { rolePermissions } = storeToRefs(authStore)
const isModalOpen = ref(false)

const handleSelect = (userCompany: UserCompany) => {
  if (!isSelected(userCompany.company.id)) {
    authStore.selectCompany(userCompany.company.id)
    emits('onSelect')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(rolePermissions)?.includes(_unref(PERMISSIONS).ADD_COMPANY))
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 0,
          class: "company-switcher__add-button",
          label: _ctx.$t('addBusiness'),
          icon: "plus",
          format: _unref(FORMATS).SECONDARY,
          size: _unref(SIZES).SMALL,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalOpen.value = true))
        }, null, 8, ["label", "format", "size"]))
      : _createCommentVNode("", true),
    (__props.userCompanies.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('switchCompany')), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userCompanies, (userCompany) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(isSelected(userCompany.company.id) ? 'div' : 'button'), {
                key: userCompany.id,
                class: _normalizeClass({
            'company-switcher__item': true,
            'company-switcher__item--selected': isSelected(
              userCompany.company.id,
            ),
          }),
                onClick: () => handleSelect(userCompany)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(userCompany.company.name.slice(0, 1)), 1),
                  _createElementVNode("label", _hoisted_5, [
                    _createTextVNode(_toDisplayString(userCompany.company.name) + " ", 1),
                    (isSelected(userCompany.company.id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " - " + _toDisplayString(_ctx.$t('currentCompany')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["class", "onClick"]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (isModalOpen.value)
      ? (_openBlock(), _createBlock(ModalWrapper, {
          key: 2,
          title: _ctx.$t('addNewBusiness'),
          "modal-size": _unref(SIZES).MEDIUM,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (isModalOpen.value = false))
        }, {
          content: _withCtx(() => [
            _createVNode(FormCreateCompany, {
              onClose: _cache[1] || (_cache[1] = ($event: any) => (isModalOpen.value = false))
            })
          ]),
          _: 1
        }, 8, ["title", "modal-size"]))
      : _createCommentVNode("", true)
  ]))
}
}

})